export const createInitialTableState = (initConfig = {}, name = 'tableSetting') => {
    return {
        [name]: {
            currentPage: 0,
            filterValueList: {},
            rowsPerPage: 20,
            hiddenColumns: [],
            ...initConfig,
        },
    }
}

export const createTableSettingSelector = (selectOwnState, name = 'tableSetting') => (state) => {
    return selectOwnState(state)[name]
}

export const changeTableSettings = (propertyName = 'tableSetting') => (state, action) => {
    const { name, value } = action.payload
    return {
        ...state,
        [propertyName]: {
            ...state[propertyName],
            [name]: value,
        },
    }
}

export const createChangeTableSettingAction = (type) => (name, value) => {
    return {
        type,
        payload: {
            name,
            value,
        },
    }
}


// WEBPACK FOOTER //
// ./src/modules/form/state/table-state-helper.js